import './body-wrap.scss';

import * as gzBodyWrapDirective from './body-wrap.directive';

export default angular.module('gazelle.components.bodyWrap', [
])
  .directive(gzBodyWrapDirective.name, gzBodyWrapDirective.default)
  .name;



// WEBPACK FOOTER //
// ../~/@printos/gazelle/src/components/body-wrap/body-wrap.module.js